module.exports = __webpack_public_path__ + "img/eg.6b83ab95.svg";